import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@unite-us/ui';
import { TextButton } from '@unite-us/app-components';
import AuthorizationHistoryCard from './AuthorizationHistoryCard';
import useAuthorizationWithLineage from '../../../../pages/service-authorizations/hooks/useAuthorizationWithLineage';

const AuthorizationHistoryButton = ({
  serviceAuthorization,
}) => {
  const modalRef = useRef();

  const {
    lineageAuthorizations,
  } = useAuthorizationWithLineage(serviceAuthorization);

  const lineageLatestFirst = [...lineageAuthorizations].reverse();

  const openModal = () => {
    if (modalRef.current) {
      modalRef.current.openDialog();
    }
  };

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.closeDialog();
    }
  };

  return (
    <>
      <TextButton
        onClick={openModal}
        className="text-sm font-semibold leading-5 mt-2 outline-none focus:outline-none"
      >
        See details
      </TextButton>

      <Dialog
        ref={modalRef}
        title="Changes to authorization requested"
        size="large"
        onRequestClose={closeModal}
      >
        <div className="space-y-6">
          <h3 className="text-lg font-semibold leading-7 tracking-normal text-black">
            Current Authorization Request
          </h3>
          <AuthorizationHistoryCard
            authorization={lineageLatestFirst[0]}
          />
          <h3 className="text-lg font-semibold leading-7 tracking-normal text-black">
            Previous Authorization Requests
          </h3>
          {lineageLatestFirst.slice(1).map((auth) => (
            <AuthorizationHistoryCard
              key={auth.id}
              authorization={auth}
            />
          ))}
        </div>
      </Dialog>
    </>
  );
};

AuthorizationHistoryButton.propTypes = {
  serviceAuthorization: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default AuthorizationHistoryButton;
